<!--Table-->
<div class="ReminderHeader">
	<h4 style="text-align: center; margin: 0px">Current Reminders</h4>
</div>
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstStationReminderAlert"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		[multiSortMeta]="multiSortMeta"
		styleClass="p-datatable-striped"
		selectionMode="single"
		(sortFunction)="OrderSort($event)"
		[customSort]="true"
		[(selection)]="SelectedStationReminderAlert"
		dataKey="StationReminderAlertID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->

			<!-- <tr> -->

			<!--INSERT CUSTOM FILTERS HERE-->

			<!--Message-->
			<!-- <th>
                    <p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
                </th> -->

			<!--SoundFile-->
			<!-- <th>
                    <p-columnFilter type="text" field="SoundFile" matchMode="contains" [showMenu]="true"></p-columnFilter>
                </th> -->

			<!--AlertTypeDesc-->
			<!-- <th>
					<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterAlertTypeDesc [ngModel]="value" [options]="lstAlertTypeDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th> -->

			<!--RangeDesc-->
			<!-- <th>
                    <p-columnFilter type="text" field="RangeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
                </th> -->

			<!-- </tr> -->

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th class="OrderColumn" pSortableColumn="ZOrder">
					<p-sortIcon field="ZOrder"></p-sortIcon>
				</th>

				<th>Message</th>
				<th>Sound</th>
				<th class="OccurColumn">Occurs</th>
				<th class="NextOccurColumn">Next Occurrence</th>
				<th class="CheckColumn" pSortableColumn="EntryMode">Entry<p-sortIcon field="EntryMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="ExitMode">Exit<p-sortIcon field="ExitMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="MealMode">Meal<p-sortIcon field="MealMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="AccessMode">Access<p-sortIcon field="AccessMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="TimeStampMode">Time Stamp<p-sortIcon field="TimeStampMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="EventEntryMode">Event Entry<p-sortIcon field="EventEntryMode"></p-sortIcon></th>
				<th class="CheckColumn" pSortableColumn="EventExitMode">Event Exit<p-sortIcon field="EventExitMode"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-StationReminderAlert>
			<tr [pSelectableRow]="StationReminderAlert">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="OrderColumn CenterText">
					{{ StationReminderAlert.ZOrder }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="StationReminderAlert.MessageFontColor">
					{{ StationReminderAlert.Message }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationReminderAlert.SoundFile }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="OccurColumn">
					{{ StationReminderAlert.AlertTypeDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" class="NextOccurColumn">
					{{ StationReminderAlert.RangeDesc }}
				</td>

				<td class="CheckColumn" *ngFor="let col of ModeCols">
					<i *ngIf="StationReminderAlert[col.field] == true" class="pi pi-check-circle active-color IconFont"></i>
					<i *ngIf="StationReminderAlert[col.field] == false" class="pi pi-ban inactive-color IconFont"></i>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
